import React from "react";
import { usePayment } from "../contexts/PaymentContext";
import styles from "./PlanStatusBadge.module.css";

export default function PlanStatusBadge() {
  const { status, statusLoading, triggerUpgrade } = usePayment();

  if (statusLoading || !status) return null;

  const isUnlimited = status.unlimited?.active === true;
  const credits = status.credits ?? 0;
  const hasPaidCredits = credits > 0;
  const dailyUsed = status.freeUsage?.used ?? 0;
  const dailyLimit = status.freeUsage?.limit ?? 5;
  const dailyRemaining = Math.max(0, dailyLimit - dailyUsed);
  const hasFreeLeft = dailyRemaining > 0;

  // Determine which tier for display
  const isFree = !isUnlimited && !hasPaidCredits;

  const isLow = isUnlimited
    ? false
    : hasPaidCredits
    ? !hasFreeLeft && credits <= 3
    : dailyRemaining <= 1;

  function handleClick() {
    if (isUnlimited) return;
    if (isLow) {
      triggerUpgrade({
        message: isFree
          ? `You've used ${dailyUsed} of ${dailyLimit} free AI messages today`
          : "Running low on credits!",
      });
    }
  }

  function getTitle() {
    if (isUnlimited) return `Unlimited Pro — expires ${new Date(status.unlimited.expiresAt).toLocaleDateString()}`;
    if (hasPaidCredits && hasFreeLeft) return `${dailyRemaining} free left today, then ${credits} paid credit${credits !== 1 ? "s" : ""}`;
    if (hasPaidCredits) return `${credits} AI credit${credits !== 1 ? "s" : ""} remaining (free quota used)`;
    return `${dailyRemaining} of ${dailyLimit} free AI messages left today`;
  }

  return (
    <button
      className={`${styles.badge} ${isUnlimited ? styles.badgePro : ""} ${
        isLow ? styles.badgeLow : ""
      }`}
      onClick={handleClick}
      title={getTitle()}
    >
      {isUnlimited ? (
        <>
          <span className={styles.icon}>⚡</span>
          <span>Unlimited</span>
        </>
      ) : hasPaidCredits ? (
        <>
          {hasFreeLeft && (
            <>
              <span className={styles.icon}>✨</span>
              <span>{dailyRemaining}/{dailyLimit} free</span>
              <span className={styles.separator}>│</span>
            </>
          )}
          <span className={styles.icon}>🎯</span>
          <span>{credits} credit{credits !== 1 ? "s" : ""}</span>
        </>
      ) : (
        <>
          <span className={styles.icon}>✨</span>
          <span>{dailyRemaining}/{dailyLimit} today</span>
        </>
      )}
    </button>
  );
}
